import * as z from "zod";

const pendingEmailCorrection = z.object({
  id: z.string(),
  rawEmail: z.string(),
  suggestedEmail: z.string(),
  editDistance: z.number(),
  teamId: z.string().nullable(),
  teamName: z.string().nullable(),
  createdAt: z.date(),
});

export const listPendingEmailCorrections = {
  name: "listPendingEmailCorrections" as const,
  input: z.object({}),
  output: z.object({ corrections: z.array(pendingEmailCorrection) }),
};
